import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { DataLineageSettingsGitModel, DataLineageStoreModel } from './data-lineage.model';

@Injectable({ providedIn: 'root' })
export class DataLineageGitService extends AbstractFeatureGitService<DataLineageStoreModel, Y42GitFolders.Lineage> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      errorHandlerService,
      name: 'DataLineage-Git',
      basePath: getY42GitPath(Y42GitFolders.Lineage),
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: DataLineageSettingsGitModel,
        },
      },
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          childType: 'folder',
          models: {
            linkDataArray: {
              fileName: 'settings.json',
              property: 'linkDataArray',
            },
            nodeDataArray: {
              fileName: 'settings.json',
              property: 'nodeDataArray',
            },
            visualDataArray: {
              fileName: 'settings.json',
              property: 'visualDataArray',
            },
            selectedFilters: {
              fileName: 'settings.json',
              property: 'selectedFilters',
            },
          },
        },
      },
    });
  }

  async create(lineage: DataLineageStoreModel): Promise<void> {
    const id = lineage.$name;
    await this.git.createFolder(this.getPath(id), { skipSync: true });
    await this.git.writeFiles([
      {
        path: this.getPath(id, this.cfg.models!.metadata.fileName),
        content: new Y42MetadataGitModel(lineage),
      },
      {
        path: this.getPath(id, this.cfg.models!.settings!.fileName),
        content: new DataLineageSettingsGitModel(lineage),
      },
    ]);
  }
}
